export default "__VITE_ASSET__a0Vr1ddK__"